/**
 * Provider Lead (Studio empfehlen) – Public API, nur API-Key nötig.
 * Endpoint und API Key aus AWS AppSync Konsole:
 * REACT_APP_PROVIDER_LEAD_GRAPHQL_ENDPOINT
 * REACT_APP_PROVIDER_LEAD_API_KEY
 */

export const SUBMIT_PROVIDER_LEAD = `
  mutation SubmitProviderLead($input: SubmitProviderLeadInput!) {
    submitProviderLead(input: $input) {
      success
      message
      leadID
    }
  }
`;

/** GraphQL endpoint for provider lead (public API). Fallback to main AppSync if not set. */
export const getProviderLeadConfig = () => ({
  endpoint:
    process.env.REACT_APP_PROVIDER_LEAD_GRAPHQL_ENDPOINT ||
    process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  apiKey:
    process.env.REACT_APP_PROVIDER_LEAD_API_KEY ||
    process.env.REACT_APP_AWS_APPSYNC_API_KEY,
});
